import {
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { DropdownMenu } from "@/components/ui/dropdown-menu";
import { Plus } from "lucide-react";

import { DropdownMenuContent } from "@/components/ui/dropdown-menu";
import { ComponentType, GroupParam } from "@/queries/models/types";
import { PARAMETER_DEFAULT_VALUES, PARAMETER_TYPES } from "../../constants";
import { ParameterIcon } from "../../ParameterIcon";
import { BuilderProps } from "../types";

export const AddNewGroupParameter = ({
  parameter,
  isViewing,
  isNested,
}: BuilderProps) => {
  const handleAddParameterToGroup = (type: ComponentType) => {
    if (!parameter) return;

    const groupParam = parameter.getParameter as GroupParam;

    let highestNumber = 0;
    (groupParam.parameters || []).forEach((param) => {
      if (param.param_id && param.param_id.startsWith(`${type}_`)) {
        highestNumber++;
      }
    });

    const newParamId = `${type}_${highestNumber + 1}`;

    const newParam = {
      ...PARAMETER_DEFAULT_VALUES[type],
      param_id: newParamId,
    };

    const updatedParameters = [...(groupParam.parameters || []), newParam];

    parameter.updateGroupParameters(updatedParameters);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger hideChevron disabled={isViewing}>
        <div className="mr-2 flex items-center gap-2">
          <Plus className={`${isNested ? "h-3.5 w-3.5" : "h-4 w-4"}`} />
          <div className={`${isNested ? "text-xs" : ""}`}>Add Parameter</div>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {PARAMETER_TYPES.map((type) => (
          <DropdownMenuItem
            key={type.value}
            onClick={() => handleAddParameterToGroup(type.value)}
          >
            <div className="flex items-center gap-2">
              <ParameterIcon type={type.value} />
              {type.label}
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
